module.exports = __webpack_public_path__ + "static/waltz_kore_za_tortu_1-bd476f4f2c31f62d58c0548f265dc48b.jpg";